import { CardContent, Grid } from '@mui/material';
import { formatCurrency } from 'common/constants/currency';
import { useStoreSelector } from 'v3/data/store';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { BodySmallRegularStyled, CardHeaderStyled, CardStyled, Content, TextBreakable } from '../styles';

export const OnlineTransactionInformation = () => {
  const { paymentDetails } = useStoreSelector((store) => store.onlineContracting);

  return (
    <CardStyled>
      <CardHeaderStyled
        title={
          <Content>
            <SubtitleLarge>Transação</SubtitleLarge>
          </Content>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>ID do pagamento</BodySmallRegularStyled>
            <TextBreakable>
              <BodySmallRegular className="empty-line">{paymentDetails?.paymentId || ''}</BodySmallRegular>
            </TextBreakable>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Meio pagamento</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">
              {paymentDetails.totalValue ? 'DimoFinancing' : ''}
            </BodySmallRegular>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Total da compra</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">
              {paymentDetails?.totalValue ? formatCurrency(paymentDetails.totalValue) : ''}
            </BodySmallRegular>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Status</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">{paymentDetails?.paymentStatus || ''}</BodySmallRegular>
          </Grid>
        </Grid>
      </CardContent>
    </CardStyled>
  );
};
